let bgHeight = "";
const calcSize = (el, deg) => {
	let container = $('.container');
	let originWidth = container.width();
	let originHeight = container.height();
	let radian = deg * Math.PI / 180;
	let edge = originHeight * Math.tan(radian);

	$(el).css({
		'margin-left': -(originWidth + edge) / 2 + 'px',
		'width': (originWidth + edge) + 'px'
	});
	$('.reverse').css({
		'width' : (originWidth) / 2 + 'px'
	});
};


calcSize('.bg-img', 18);

$(window).resize(() => {
	calcSize('.bg-img', 18);
});

let CTRL1 = $('.class-ctrl__1');
let CTRL2 = $('.class-ctrl__2');
let CTRL3 = $('.class-ctrl__3');
let CTRL4 = $('.class-ctrl__4');
let CTRL5 = $('.class-ctrl__5');
let CTRL6 = $('.class-ctrl__6');
let CTRL7 = $('.class-ctrl__7');
let CTRL8 = $('.class-ctrl__8');
let CTRL9 = $('.class-ctrl__9');
let CTRL10 = $('.class-ctrl__10');
let CTRL11 = $('.class-ctrl__11');

let now = '';

const introTimeline = new TimelineMax({
	paused: true
});

let isAnimated = false;
let isDetail = false;
introTimeline.addLabel('init')
	.to('.intro .sub_nav', 0.1, {
		display: 'none',
		opacity: 0
	}, 0)
	.from($('.intro_tit'), 0.84, {
		y: -15,
		alpha: 0,
		ease: Power3.easeOut
	}, "init+=0.8")
	.from($('.intro_txt'), 0.84, {
		y: 10,
		alpha: 0,
		ease: Power3.easeOut
	}, "init+=1.3")
	.from($('.class-ctrl'), 0.8, {
		alpha: 0,
		ease: Power3.easeInOut
	}, "init+=1.5");


const resetIndex = () => {

};

const offIndex = () => {
	$('.intro-info-wrap').hide();
};

const onIndex = () => {
	$('.intro-info-wrap').css({
		opacity: 1
	}).show();
	$('.class-detail-wrap').css({
		opacity: 0
	});
	$('.class__detail').removeAttr('style');
};

const offDetail = () => {
	TweenMax.to('.intro .sub_nav', 0.1, {
		display: 'none',
		opacity: 0
	}, 0)

	$('.class-scean-1 .reverse *').removeAttr('style');
	$('.class-scean-2 .reverse *').removeAttr('style');

};

const detailToggle = (name) => {
	$('.class__detail').css({
		'z-index': 0
	});
	$(name).css({
		'z-index': 4,
		'opacity': 1
	});
	//$(window).resize();
};

const resetAnimation = () => {

	$('.class-detail-wrap .sub_nav li').removeClass('on');
	TweenMax.to('.intro-info-wrap', '0.6', {
		opacity: 1,
		ease: Quint.easeInOut
	});
	introTimeline.seek(0);
	introTimeline.pause(0);

	mainScene.class1.seek(0);
	mainScene.class1.pause();

	mainScene.class2.seek(0);
	mainScene.class2.pause();

	mainScene.class3.seek(0);
	mainScene.class3.pause();

	mainScene.class4.seek(0);
	mainScene.class4.pause();

	mainScene.class5.seek(0);
	mainScene.class5.pause();

	mainScene.class6.seek(0);
	mainScene.class6.pause();

	mainScene.class7.seek(0);
	mainScene.class7.pause();

	mainScene.class8.seek(0);
	mainScene.class8.pause();

	mainScene.class9.seek(0);
	mainScene.class9.pause();

	mainScene.class10.seek(0);
	mainScene.class10.pause();

	mainScene.class11.seek(0);
	mainScene.class11.pause();

	detailScene.class1.seek(0);
	detailScene.class1.pause();

	detailScene.class2.seek(0);
	detailScene.class2.pause();

	detailScene.class3.seek(0);
	detailScene.class3.pause();

	detailScene.class4.seek(0);
	detailScene.class4.pause();

	detailScene.class5.seek(0);
	detailScene.class5.pause();

	detailScene.class6.seek(0);
	detailScene.class6.pause();

	detailScene.class7.seek(0);
	detailScene.class7.pause();

	detailScene.class8.seek(0);
	detailScene.class8.pause();

	detailScene.class9.seek(0);
	detailScene.class9.pause();

	detailScene.class10.seek(0);
	detailScene.class10.pause();

	detailScene.class11.seek(0);
	detailScene.class11.pause();

	$('.class-detail-wrap').removeAttr('style');
	$('.class-scean-1 .reverse *').removeAttr('style');
	$('.class-scean-2 .reverse *').removeAttr('style');
};


$(document).on('mouseover', '.class-ctrl .btnDiv', function (e) {
	$('.class-ctrl').addClass('disabled');
	$('.class-ctrl .btnDiv').addClass('disabled');
	$(this).removeClass('disabled');
}).on('mouseout', '.class-ctrl .btnDiv', function (e) {
	$('.class-ctrl').removeClass('disabled');
	$('.class-ctrl .btnDiv').removeClass('disabled');
});

const detailScene = {
	class1: new TimelineMax({
		paused: true
	}),
	class2: new TimelineMax({
		paused: true
	}),
	class3: new TimelineMax({
		paused: true
	}),
	class4: new TimelineMax({
		paused: true
	}),
	class5: new TimelineMax({
		paused: true
	}),
	class6: new TimelineMax({
		paused: true
	}),
	class7: new TimelineMax({
		paused: true
	}),
	class8: new TimelineMax({
		paused: true
	}),
	class9: new TimelineMax({
		paused: true
	}),
	class10: new TimelineMax({
		paused: true
	}),
	class11: new TimelineMax({
		paused: true
	})
};

//클래스 상세(검사)
detailScene.class1.addLabel('init')
	.add(() => {
		detailToggle('.class__detail--1');
	}, 'init')
	.fromTo('.class__detail--1 .bg-con', '0.6', {bottom:'100%'}, {bottom:0, ease: Expo.easeInOut}, 'init')
	.fromTo('.class-detail-wrap .sub_nav', 1, {display: 'none', opacity: 0},{display: 'block',opacity: 1}, 'init+=0.5')
	.add(() => {
		$('.class-detail-wrap .sub_nav li').removeClass('on');
		$('.class-detail-wrap .sub_nav .class1').addClass('on');
	}, 'init+=0.1')
	.fromTo('.class__detail--1 .class-char__1-1', '1', {alpha: 0, marginRight: -200}, {alpha:0.1, marginRight:0, ease: Expo.easeInOut}, 'init+=.5')
	.fromTo('.class__detail--1 .class-char__1-2', '1', {alpha: 0, marginRight: -200}, {alpha:0.4, marginRight:0, ease: Expo.easeInOut}, 'init+=.55')
	.fromTo('.class__detail--1 .class-char__1-3', '1', {alpha: 0, marginRight: -200}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=.6')
	.fromTo('.class__detail--1 .class-char__1 .fx', '2', {alpha: 0}, {alpha:1, ease: Expo.easeInOut}, 'init+=0.6')
	.add(() => {
		TweenMax.fromTo('.class__detail--1 .class-char__1 .fx', 2, {opacity:1}, {delay: 2, opacity:0.6, repeat:-1, repeatDelay:0,  yoyo:true,  ease:Sine.easeInOut});
	}, 'init+=0.6')
	.fromTo('.class__detail--1 .class-char__2-1', '0.8', {alpha: 0, marginLeft: -200}, {alpha:0.1, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.0')
	.fromTo('.class__detail--1 .class-char__2-2', '0.8', {alpha: 0, marginLeft: -200}, {alpha:0.4, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.05')
	.fromTo('.class__detail--1 .class-char__2-3', '0.8', {alpha: 0, marginLeft: -200}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.1')
	.staggerFromTo('.class__detail--1 .class-char__2 .fx', 0.5, {alpha: 0}, {alpha: 1, ease: Circ.easeOut}, 0.25, "init+=1.6")
	.fromTo('.class__detail--1 .class-tit__1', '1', {alpha: 0, marginRight: 50}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=1.7')
	.fromTo('.class__detail--1 .class-txt__1', '1', {alpha: 0, marginRight: 50}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=1.8')
	.fromTo('.class__detail--1 .class-tit__2', '1', {alpha: 0, marginLeft: -50}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=2.2')
	.fromTo('.class__detail--1 .class-txt__2', '1', {alpha: 0, marginLeft: -50}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=2.3');

//클래스 상세(권사)
detailScene.class2.addLabel('init')
	.add(() => {
		detailToggle('.class__detail--2');
	}, 'init')
	.fromTo('.class__detail--2 .bg-con', '0.6', {bottom:'100%'}, {bottom:0, ease: Expo.easeInOut}, 'init')
	.fromTo('.class-detail-wrap .sub_nav', 1, {display: 'none', opacity: 0},{display: 'block',opacity: 1}, 'init+=0.5')
	.add(() => {
		$('.class-detail-wrap .sub_nav li').removeClass('on');
		$('.class-detail-wrap .sub_nav .class2').addClass('on');
	}, 'init+=0.5')
	.fromTo('.class__detail--2 .class-char__1-1', '1', {alpha: 0, marginRight: 200}, {alpha:0.1, marginRight:0, ease: Expo.easeInOut}, 'init+=.5')
	.fromTo('.class__detail--2 .class-char__1-2', '1', {alpha: 0, marginRight: 200}, {alpha:0.4, marginRight:0, ease: Expo.easeInOut}, 'init+=.55')
	.fromTo('.class__detail--2 .class-char__1-3', '1', {alpha: 0, marginRight: 200}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=.6')
	//.fromTo('.class__detail--2 .class-char__1 .fx', '2', {alpha: 0}, {opacity:1, ease: Expo.easeInOut}, 'init+=0.4')
	.add(() => {
		TweenMax.fromTo('.class__detail--2 .class-char__1 .fx', 2, {opacity:0.5}, {delay: 2, opacity:1, repeat:-1, repeatDelay:0,  yoyo:true,  ease:Bounce.easeInOut});
	}, 'init+=0.5')
	.fromTo('.class__detail--2 .class-char__2-1', '0.8', {alpha: 0, marginLeft: -200, marginTop:-150}, {alpha:0.1, marginLeft:0, marginTop:0, ease: Expo.easeInOut}, 'init+=1.0')
	.fromTo('.class__detail--2 .class-char__2-2', '0.8', {alpha: 0,  marginLeft: -200, marginTop:-150}, {alpha:0.4, marginLeft:0, marginTop:0, ease: Expo.easeInOut}, 'init+=1.05')
	.fromTo('.class__detail--2 .class-char__2-3', '0.8', {alpha: 0,  marginLeft: -200, marginTop:-150}, {alpha:1, marginLeft:0, marginTop:0, ease: Expo.easeInOut}, 'init+=1.1')
	.staggerFromTo('.class__detail--2 .class-char__2 .fx', 0.5, {alpha: 0}, {alpha: 1, ease: Circ.easeOut}, 0.5, "init+=1.6")
	.fromTo('.class__detail--2 .class-tit__1', '1', {alpha: 0, marginRight: 50}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=1.7')
	.fromTo('.class__detail--2 .class-txt__1', '1', {alpha: 0, marginRight: 50}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=1.8')
	.fromTo('.class__detail--2 .class-tit__2', '1', {alpha: 0, marginLeft: -50}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=2.2')
	.fromTo('.class__detail--2 .class-txt__2', '1', {alpha: 0, marginLeft: -50}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=2.3');

//클래스 상세(역사)
detailScene.class3.addLabel('init')
	.add(() => {
		detailToggle('.class__detail--3');
	}, 'init')
	.fromTo('.class__detail--3 .bg-con', '0.6', {bottom:'100%'}, {bottom:0, ease: Expo.easeInOut}, 'init')
	.fromTo('.class-detail-wrap .sub_nav', 1, {display: 'none', opacity: 0},{display: 'block',opacity: 1}, 'init+=0.5')
	.add(() => {
		$('.class-detail-wrap .sub_nav li').removeClass('on');
		$('.class-detail-wrap .sub_nav .class3').addClass('on');
	}, 'init+=0.5')
	.fromTo('.class__detail--3 .class-char__1-1', '1', {alpha: 0, marginRight: -200}, {alpha:0.1, marginRight:0, ease: Expo.easeInOut}, 'init+=.5')
	.fromTo('.class__detail--3 .class-char__1-2', '1', {alpha: 0, marginRight: -200}, {alpha:0.4, marginRight:0, ease: Expo.easeInOut}, 'init+=.55')
	.fromTo('.class__detail--3 .class-char__1-3', '1', {alpha: 0, marginRight: -200}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=.6')
	//.fromTo('.class__detail--3 .class-char__1_f_2', '1', {alpha: 0}, {opacity:1, ease: Expo.easeInOut}, 'init+=.6')
	.fromTo('.class__detail--3 .class-char__1_f_1', '2', {alpha: 0}, {opacity:1, ease: Expo.easeInOut}, 'init+=.65')
	.add(() => {
		TweenMax.fromTo('.class__detail--3 .class-char__1_f_2', 3.5, {opacity:0}, {delay: 3.5, opacity:1, repeat:-1, repeatDelay:0,  yoyo:true,  ease:Sine.easeInOut});
	}, 'init+=0.6')
	.fromTo('.class__detail--3 .class-char__2-1', '0.8', {alpha: 0, marginLeft: -200}, {alpha:0.1, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.0')
	.fromTo('.class__detail--3 .class-char__2-2', '0.8', {alpha: 0,  marginLeft: -200}, {alpha:0.4, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.05')
	.fromTo('.class__detail--3 .class-char__2-3', '0.8', {alpha: 0,  marginLeft: -200}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.1')
	.fromTo('.class__detail--3 .class-char__2_f_1', '1', {alpha: 0}, {opacity:1, ease: Expo.easeInOut}, 'init+=1.1')
	.fromTo('.class__detail--3 .class-char__2_f_2', '2', {alpha: 0}, {opacity:1, ease: Expo.easeInOut}, 'init+=1.15')
	.fromTo('.class__detail--3 .class-tit__1', '1', {alpha: 0, marginRight: 50}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=1.7')
	.fromTo('.class__detail--3 .class-txt__1', '1', {alpha: 0, marginRight: 50}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=1.8')
	.fromTo('.class__detail--3 .class-tit__2', '1', {alpha: 0, marginLeft: -50}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=2.2')
	.fromTo('.class__detail--3 .class-txt__2', '1', {alpha: 0, marginLeft: -50}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=2.3');

//클래스 상세(소환사)
detailScene.class4.addLabel('init')
	.add(() => {
		detailToggle('.class__detail--4');
	}, 'init')
	.fromTo('.class__detail--4 .bg-con', '0.6', {bottom:'100%'}, {bottom:0, ease: Expo.easeInOut}, 'init')
	.fromTo('.class-detail-wrap .sub_nav', 1, {display: 'none', opacity: 0},{display: 'block',opacity: 1}, 'init+=0.5')
	.add(() => {
		$('.class-detail-wrap .sub_nav li').removeClass('on');
		$('.class-detail-wrap .sub_nav .class4').addClass('on');
	}, 'init+=0.5')
	.fromTo('.class__detail--4 .class-char__1-1', '1', {alpha: 0, marginRight: -200}, {alpha:0.1, marginRight:0, ease: Expo.easeInOut}, 'init+=.5')
	.fromTo('.class__detail--4 .class-char__1-2', '1', {alpha: 0, marginRight: -200}, {alpha:0.4, marginRight:0, ease: Expo.easeInOut}, 'init+=.55')
	.fromTo('.class__detail--4 .class-char__1-3', '1', {alpha: 0, marginRight: -200}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=.6')
	.fromTo('.class__detail--4 .class-char__1_f_2', '1', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=.8')
	.fromTo('.class__detail--4 .class-char__1_f_3', '0.5', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=.85')
	.fromTo('.class__detail--4 .class-char__1_f_1', '2', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=.86')
	.add(() => {
		TweenMax.fromTo('.class__detail--4 .class-char__1_f_1', 4, {marginTop:0},{delay: 1 + Math.random(1.5), marginTop:5 + Math.random(0.75), repeat:-1, repeatDelay:0,    yoyo:true,  ease: SlowMo.ease.config(0.7, 0.4, false)});
	}, 'init+=0.91')
	.fromTo('.class__detail--4 .class-char__2-1', '0.8', {alpha: 0, marginLeft: -200}, {alpha:0.1, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.0')
	.fromTo('.class__detail--4 .class-char__2-2', '0.8', {alpha: 0,  marginLeft: -200}, {alpha:0.4, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.05')
	.fromTo('.class__detail--4 .class-char__2-3', '0.8', {alpha: 0,  marginLeft: -200}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.1')
	.fromTo('.class__detail--4 .class-char__2_f_1', '2', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=1.3')
	.fromTo('.class__detail--4 .class-char__2_f_2', '1', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=1.35')
	.fromTo('.class__detail--4 .class-char__2_f_3', '0.5', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=1.4')
	.add(() => {
		TweenMax.fromTo('.class__detail--4 .class-char__2_f_2', 2.5, {opacity:0.9, marginTop:0},{delay: 2,  opacity:1,  repeat:-1, repeatDelay:0,  yoyo:true, ease: Bounce.easeInOut, marginTop: 10});
	}, 'init+=1.45')
	.fromTo('.class__detail--4 .class-tit__1', '1', {alpha: 0, marginRight: 50}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=1.7')
	.fromTo('.class__detail--4 .class-txt__1', '1', {alpha: 0, marginRight: 50}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=1.8')
	.fromTo('.class__detail--4 .class-tit__2', '1', {alpha: 0, marginLeft: -50}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=2.2')
	.fromTo('.class__detail--4 .class-txt__2', '1', {alpha: 0, marginLeft: -50}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=2.3');

//클래스 상세(기공사)
detailScene.class5.addLabel('init')
	.add(() => {
		detailToggle('.class__detail--5');
	}, 'init')
	.fromTo('.class__detail--5 .bg-con', '0.6', {bottom:'100%'}, {bottom:0, ease: Expo.easeInOut}, 'init')
	.fromTo('.class-detail-wrap .sub_nav', 1, {display: 'none', opacity: 0},{display: 'block',opacity: 1}, 'init+=0.5')
	.add(() => {
		$('.class-detail-wrap .sub_nav li').removeClass('on');
		$('.class-detail-wrap .sub_nav .class5').addClass('on');
	}, 'init+=0.5')
	.fromTo('.class__detail--5 .class-char__1-1', '1', {alpha: 0, marginRight: -200}, {alpha:0.1, marginRight:0, ease: Expo.easeInOut}, 'init+=.5')
	.fromTo('.class__detail--5 .class-char__1-2', '1', {alpha: 0, marginRight: -200}, {alpha:0.4, marginRight:0, ease: Expo.easeInOut}, 'init+=.55')
	.fromTo('.class__detail--5 .class-char__1-3', '1', {alpha: 0, marginRight: -200}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=.6')
	//.fromTo('.class__detail--5 .class-char__1_f_2', '1', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=.6')
	.fromTo('.class__detail--5 .class-char__1_f_3', '0.5', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=.63')
	.fromTo('.class__detail--5 .class-char__1_f_1', '2', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=.75')
	.fromTo('.class__detail--5 .class-char__1_f_4', '0.7', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=.83')
	.fromTo('.class__detail--5 .class-char__1_f_5', '2', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=.85')
	.add(() => {
		TweenMax.fromTo('.class__detail--5 .class-char__1_f_2', 2.5, {opacity:0, marginTop:0},{delay: 2,  opacity:1,  repeat:-1, repeatDelay:0,  yoyo:true, ease: Bounce.easeInOut, marginTop: -7});
	}, 'init+=0.85')
	.fromTo('.class__detail--5 .class-char__2-1', '0.8', {alpha: 0, marginLeft: -200}, {alpha:0.1, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.0')
	.fromTo('.class__detail--5 .class-char__2-2', '0.8', {alpha: 0,  marginLeft: -200}, {alpha:0.4, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.05')
	.fromTo('.class__detail--5 .class-char__2-3', '0.8', {alpha: 0,  marginLeft: -200}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.1')
	.fromTo('.class__detail--5 .class-char__2_f_1', '1', {alpha: 0}, {alpha:1, ease: Expo.easeInOut}, 'init+=1.2')
	.fromTo('.class__detail--5 .class-char__2_f_2', '1', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=1.1')
	.fromTo('.class__detail--5 .class-char__2_f_3', '0.5', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=1.1')
	.add(() => {
		TweenMax.fromTo('.class__detail--5 .class-char__2_f_1', 2.5, {marginTop:0},{delay: 2,  repeat:-1, repeatDelay:0,  yoyo:true, ease: Bounce.easeInOut, marginTop: -7});
	}, 'init+=0.85')
	.fromTo('.class__detail--5 .class-tit__1', '1', {alpha: 0, marginRight: 50}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=1.7')
	.fromTo('.class__detail--5 .class-txt__1', '1', {alpha: 0, marginRight: 50}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=1.8')
	.fromTo('.class__detail--5 .class-tit__2', '1', {alpha: 0, marginLeft: -50}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=2.2')
	.fromTo('.class__detail--5 .class-txt__2', '1', {alpha: 0, marginLeft: -50}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=2.3');

//클래스 상세(암살자)
detailScene.class6.addLabel('init')
	.add(() => {
		detailToggle('.class__detail--6');
	}, 'init')
	.fromTo('.class__detail--6 .bg-con', '0.6', {bottom:'100%'}, {bottom:0, ease: Expo.easeInOut}, 'init')
	.fromTo('.class-detail-wrap .sub_nav', 1, {display: 'none', opacity: 0},{display: 'block',opacity: 1}, 'init+=0.5')
	.add(() => {
		$('.class-detail-wrap .sub_nav li').removeClass('on');
		$('.class-detail-wrap .sub_nav .class6').addClass('on');
	}, 'init+=0.5')
	.fromTo('.class__detail--6 .class-char__1-1', '1', {alpha: 0, marginRight: -200}, {alpha:0.1, marginRight:0, ease: Expo.easeInOut}, 'init+=.5')
	.fromTo('.class__detail--6 .class-char__1-2', '1', {alpha: 0, marginRight: -200}, {alpha:0.4, marginRight:0, ease: Expo.easeInOut}, 'init+=.55')
	.fromTo('.class__detail--6 .class-char__1-3', '1', {alpha: 0, marginRight: -200}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=.6')
	//.fromTo('.class__detail--6 .class-char__1_f_1', '1', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=.95')
	//.fromTo('.class__detail--6 .class-char__1_f_2', '1', {alpha: 0.5}, {alpha: 1, ease: Power3.easeOut}, 'init+=.95')
	.add(() => {
		TweenMax.fromTo('.class__detail--6 .class-char__1 .fx', 2, {opacity:0}, {delay: 2, opacity:1, repeat:-1, repeatDelay:0,  yoyo:true,  ease:Bounce.easeInOut});
	}, 'init+=.95')
	.fromTo('.class__detail--6 .class-char__2-1', '0.8', {alpha: 0, marginLeft: -200}, {alpha:0.1, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.0')
	.fromTo('.class__detail--6 .class-char__2-2', '0.8', {alpha: 0,  marginLeft: -200}, {alpha:0.4, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.05')
	.fromTo('.class__detail--6 .class-char__2-3', '0.8', {alpha: 0,  marginLeft: -200}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.1')
	//.fromTo('.class__detail--6 .class-char__2_f_1', '1', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=1.5')
	.add(() => {
		TweenMax.fromTo('.class__detail--6 .class-char__2 .fx', 2, {opacity:0}, {delay: 2, opacity:1, repeat:-1, repeatDelay:0,  yoyo:true,  ease:Bounce.easeInOut});
	}, 'init+=1.15')
	.fromTo('.class__detail--6 .class-tit__1', '1', {alpha: 0, marginRight: 50}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=1.7')
	.fromTo('.class__detail--6 .class-txt__1', '1', {alpha: 0, marginRight: 50}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=1.8')
	.fromTo('.class__detail--6 .class-tit__2', '1', {alpha: 0, marginLeft: -50}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=2.2')
	.fromTo('.class__detail--6 .class-txt__2', '1', {alpha: 0, marginLeft: -50}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=2.3');

//클래스 상세(린검사)
detailScene.class7.addLabel('init')
	.add(() => {
		detailToggle('.class__detail--7');
	}, 'init')
	.fromTo('.class__detail--7 .bg-con', '0.6', {bottom:'100%'}, {bottom:0, ease: Expo.easeInOut}, 'init')
	.fromTo('.class-detail-wrap .sub_nav', 1, {display: 'none', opacity: 0},{display: 'block',opacity: 1}, 'init+=0.5')
	.add(() => {
		$('.class-detail-wrap .sub_nav li').removeClass('on');
		$('.class-detail-wrap .sub_nav .class7').addClass('on');
	}, 'init+=0.5')
	.fromTo('.class__detail--7 .class-char__1-1', '1', {alpha: 0, marginRight: -200}, {alpha:0.1, marginRight:0, ease: Expo.easeInOut}, 'init+=.5')
	.fromTo('.class__detail--7 .class-char__1-2', '1', {alpha: 0, marginRight: -200}, {alpha:0.4, marginRight:0, ease: Expo.easeInOut}, 'init+=.55')
	.fromTo('.class__detail--7 .class-char__1-3', '1', {alpha: 0, marginRight: -200}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=.6')
	.fromTo('.class__detail--7 .class-char__1_f_2', '1', {alpha: 0, scale:0.85}, {alpha: 1, scale:1, ease: Power3.easeOut}, 'init+=1.35')
	.fromTo('.class__detail--7 .class-char__1_f_1', '0.5', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=.7')
	.fromTo('.class__detail--7 .class-char__1_f_3', '0.8', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=1.45')
	/*.add(() => {
		TweenMax.fromTo('.class__detail--7 .class-char__1_f_2', 2, {opacity:1}, {delay: 2, opacity:0.65, repeat:-1, repeatDelay:0,  yoyo:true,  ease:Sine.easeInOut});
	}, 'init+=.72')*/
	.fromTo('.class__detail--7 .class-char__2-1', '0.8', {alpha: 0, marginLeft: -200}, {alpha:0.1, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.0')
	.fromTo('.class__detail--7 .class-char__2-2', '0.8', {alpha: 0,  marginLeft: -200}, {alpha:0.4, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.05')
	.fromTo('.class__detail--7 .class-char__2-3', '0.8', {alpha: 0,  marginLeft: -200}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.1')
	.fromTo('.class__detail--7 .class-char__2_f_1', '0.5', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=1.15')
	.fromTo('.class__detail--7 .class-char__2_f_2', '1', {alpha: 0, scale:0.5}, {alpha: 1, scale:1, ease: Power3.easeOut}, 'init+=1.8')
	.fromTo('.class__detail--7 .class-tit__1', '1', {alpha: 0, marginRight: 50}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=1.7')
	.fromTo('.class__detail--7 .class-txt__1', '1', {alpha: 0, marginRight: 50}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=1.8')
	.fromTo('.class__detail--7 .class-tit__2', '1', {alpha: 0, marginLeft: -50}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=2.2')
	.fromTo('.class__detail--7 .class-txt__2', '1', {alpha: 0, marginLeft: -50}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=2.3');
//클래스 상세(주술사)
detailScene.class8.addLabel('init')
	.add(() => {
		detailToggle('.class__detail--8');
	}, 'init')
	.fromTo('.class__detail--8 .bg-con', '0.6', {bottom:'100%'}, {bottom:0, ease: Expo.easeInOut}, 'init')
	.fromTo('.class-detail-wrap .sub_nav', 1, {display: 'none', opacity: 0},{display: 'block',opacity: 1}, 'init+=0.5')
	.add(() => {
		$('.class-detail-wrap .sub_nav li').removeClass('on');
		$('.class-detail-wrap .sub_nav .class8').addClass('on');
	}, 'init+=0.5')
	.fromTo('.class__detail--8 .class-char__1-1', '1', {alpha: 0, marginRight: -200}, {alpha:0.1, marginRight:0, ease: Expo.easeInOut}, 'init+=.5')
	.fromTo('.class__detail--8 .class-char__1-2', '1', {alpha: 0, marginRight: -200}, {alpha:0.4, marginRight:0, ease: Expo.easeInOut}, 'init+=.55')
	.fromTo('.class__detail--8 .class-char__1-3', '1', {alpha: 0, marginRight: -200}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=.6')
	.fromTo('.class__detail--8 .class-char__1_f_1', '0.8', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=.6')
	.fromTo('.class__detail--8 .class-char__1_f_2', '0.8', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=.85')
	.add(() => {
		TweenMax.fromTo('.class__detail--8 .class-char__1_f_1', 2, {opacity:1}, {delay: 2, opacity:0.65, repeat:-1, repeatDelay:0,  yoyo:true,  ease:Sine.easeInOut});
	}, 'init+=1.1')
	.fromTo('.class__detail--8 .class-char__2-1', '0.8', {alpha: 0, marginLeft: -200}, {alpha:0.1, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.0')
	.fromTo('.class__detail--8 .class-char__2-2', '0.8', {alpha: 0,  marginLeft: -200}, {alpha:0.4, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.05')
	.fromTo('.class__detail--8 .class-char__2-3', '0.8', {alpha: 0,  marginLeft: -200}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.1')
	.fromTo('.class__detail--8 .class-char__2_f_1', '0.5', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=1.1')
	.fromTo('.class__detail--8 .class-char__2_f_2', '0.6', {alpha: 0, scale:0.8, marginLeft:20}, {alpha: 1, scale: 1, marginLeft:0, ease: Power3.easeOut}, 'init+=1.36')
	.fromTo('.class__detail--8 .class-char__2_f_3', '1', {alpha: 0, scale:0.5}, {scale: 1, alpha: 1, ease: Power3.easeOut}, 'init+=1.39')
	.fromTo('.class__detail--8 .class-char__2_f_4', '1', {alpha: 0, scale:1.15}, {scale: 1, alpha: 1, ease: Power3.easeOut}, 'init+=1.39')
	.add(() => {
		TweenMax.fromTo('.class__detail--8 .class-char__2_f_2', 2, {opacity:1}, {delay: 2, opacity:0.35, repeat:-1, repeatDelay:0,  yoyo:true,  ease:Sine.easeInOut});
		TweenMax.fromTo('.class__detail--8 .class-char__2_f_3', 2, {opacity:1}, {delay: 2, opacity:0.65, repeat:-1, repeatDelay:0,  yoyo:true,  ease:Sine.easeInOut});
	}, 'init+=1.45')
	.fromTo('.class__detail--8 .class-tit__1', '1', {alpha: 0, marginRight: 50}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=1.7')
	.fromTo('.class__detail--8 .class-txt__1', '1', {alpha: 0, marginRight: 50}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=1.8')
	.fromTo('.class__detail--8 .class-tit__2', '1', {alpha: 0, marginLeft: -50}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=2.2')
	.fromTo('.class__detail--8 .class-txt__2', '1', {alpha: 0, marginLeft: -50}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=2.3');

//클래스 상세(기권사)
detailScene.class9.addLabel('init')
	.add(() => {
		detailToggle('.class__detail--9');
	}, 'init')
	.fromTo('.class__detail--9 .bg-con', '0.6', {bottom:'100%'}, {bottom:0, ease: Expo.easeInOut}, 'init')
	.fromTo('.class-detail-wrap .sub_nav', 1, {display: 'none', opacity: 0},{display: 'block',opacity: 1}, 'init+=0.5')
	.add(() => {
		$('.class-detail-wrap .sub_nav li').removeClass('on');
		$('.class-detail-wrap .sub_nav .class9').addClass('on');
	}, 'init+=0.5')
	.fromTo('.class__detail--9 .class-char__1-1', '1', {alpha: 0, marginRight: -200}, {alpha:0.1, marginRight:0, ease: Expo.easeInOut}, 'init+=.5')
	.fromTo('.class__detail--9 .class-char__1-2', '1', {alpha: 0, marginRight: -200}, {alpha:0.4, marginRight:0, ease: Expo.easeInOut}, 'init+=.55')
	.fromTo('.class__detail--9 .class-char__1-3', '1', {alpha: 0, marginRight: -200}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=.6')
	.fromTo('.class__detail--9 .class-char__1_f_1', '0.8', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=.61')
	.fromTo('.class__detail--9 .class-char__1_f_2', '0.8', {alpha: 0, scale:0.5}, {alpha: 1, scale: 1, ease: Power3.easeOut}, 'init+=.85')
	.add(() => {
		TweenMax.fromTo('.class__detail--9 .class-char__1_f_2', 0.8, {opacity:1},{opacity:0.8, delay: 2,  repeat:-1, repeatDelay:0,  yoyo:true, ease: Power3.easeOut});
	}, 'init+=0.87')
	.fromTo('.class__detail--9 .class-char__2-1', '0.8', {alpha: 0, marginLeft: -200}, {alpha:0.1, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.0')
	.fromTo('.class__detail--9 .class-char__2-2', '0.8', {alpha: 0,  marginLeft: -200}, {alpha:0.4, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.05')
	.fromTo('.class__detail--9 .class-char__2-3', '0.8', {alpha: 0,  marginLeft: -200}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.1')
	.fromTo('.class__detail--9 .class-char__2_f_1', '0.5', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=1.11')
	.fromTo('.class__detail--9 .class-char__2_f_2', '0.6', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=1.3')
	.fromTo('.class__detail--9 .class-char__2_f_3', '0.8', {alpha: 0, scale:0.5}, {scale: 1, alpha: 1, ease: Power3.easeOut}, 'init+=1.33')
	.add(() => {
		TweenMax.fromTo('.class__detail--9 .class-char__2_f_3', 0.8, {opacity:1},{opacity:0.8, delay: 2,  repeat:-1, repeatDelay:0,  yoyo:true, ease: Power3.easeOut});
	}, 'init+=1.35')
	.fromTo('.class__detail--9 .class-tit__1', '1', {alpha: 0, marginRight: 50}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=1.7')
	.fromTo('.class__detail--9 .class-txt__1', '1', {alpha: 0, marginRight: 50}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=1.8')
	.fromTo('.class__detail--9 .class-tit__2', '1', {alpha: 0, marginLeft: -50}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=2.2')
	.fromTo('.class__detail--9 .class-txt__2', '1', {alpha: 0, marginLeft: -50}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=2.3');

//클래스 상세(격사)
detailScene.class10.addLabel('init')
	.add(() => {
		detailToggle('.class__detail--10');
	}, 'init')
	.fromTo('.class__detail--10 .bg-con', '0.6', {bottom:'100%'}, {bottom:0, ease: Expo.easeInOut}, 'init')
	.fromTo('.class-detail-wrap .sub_nav', 1, {display: 'none', opacity: 0},{display: 'block',opacity: 1}, 'init+=0.5')
	.add(() => {
		$('.class-detail-wrap .sub_nav li').removeClass('on');
		$('.class-detail-wrap .sub_nav .class10').addClass('on');
	}, 'init+=0.5')
	.fromTo('.class__detail--10 .class-char__1-1', '1', {alpha: 0, marginRight: -200}, {alpha:0.1, marginRight:0, ease: Expo.easeInOut}, 'init+=.5')
	.fromTo('.class__detail--10 .class-char__1-2', '1', {alpha: 0, marginRight: -200}, {alpha:0.4, marginRight:0, ease: Expo.easeInOut}, 'init+=.55')
	.fromTo('.class__detail--10 .class-char__1-3', '1', {alpha: 0, marginRight: -200}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=.6')
	.fromTo('.class__detail--10 .class-char__1_f_1', '0.8', {alpha: 0, scale: 0.5}, {alpha: 1, scale:1, ease: Power3.easeOut}, 'init+=.65')
	.fromTo('.class__detail--10 .class-char__1_f_2', '0.8', {alpha: 0, scale: 0.5}, {alpha: 1, scale:1, ease: Power3.easeOut}, 'init+=.85')
	.add(() => {
		TweenMax.fromTo('.class__detail--10 .class-char__1_f_1', 2, {opacity:1}, {delay: 2, opacity:0.65, repeat:-1, repeatDelay:0,  yoyo:true,  ease:Sine.easeInOut});
		TweenMax.fromTo('.class__detail--10 .class-char__1_f_2', 2, {opacity:1}, {delay: 2, opacity:0.85, repeat:-1, repeatDelay:0,  yoyo:true,  ease:Sine.easeInOut});
	}, 'init+=1.1')
	.fromTo('.class__detail--10 .class-char__2-1', '0.8', {alpha: 0, marginLeft: -200}, {alpha:0.1, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.0')
	.fromTo('.class__detail--10 .class-char__2-2', '0.8', {alpha: 0,  marginLeft: -200}, {alpha:0.4, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.05')
	.fromTo('.class__detail--10 .class-char__2-3', '0.8', {alpha: 0,  marginLeft: -200}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=1.1')
	.fromTo('.class__detail--10 .class-char__2_f_1', '1', {alpha: 0, scale: 0.85}, {alpha: 1, scale: 1, ease: Power3.easeOut}, 'init+=1.31')
	.fromTo('.class__detail--10 .class-char__2_f_2', '1', {alpha: 0, scale: 1.2}, {alpha: 1, scale: 1, ease: Power3.easeOut}, 'init+=1.6')
	.fromTo('.class__detail--10 .class-char__2_f_3', '0.5', {alpha: 0, scale: 1.12}, {alpha: 1, scale: 1, ease: Power3.easeOut}, 'init+=1.66')
	.add(() => {
		TweenMax.fromTo('.class__detail--10 .class-char__2_f_1', 2, {opacity:1}, {delay: 2, opacity:0.65, repeat:-1, repeatDelay:0,  yoyo:true,  ease:Sine.easeInOut});
		TweenMax.fromTo('.class__detail--10 .class-char__2_f_2', 2, {opacity:1}, {delay: 2, opacity:0.85, repeat:-1, repeatDelay:0,  yoyo:true,  ease:Sine.easeInOut});
	}, 'init+=1.1')
	.fromTo('.class__detail--10 .class-tit__1', '1', {alpha: 0, marginRight: 50}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=1.7')
	.fromTo('.class__detail--10 .class-txt__1', '1', {alpha: 0, marginRight: 50}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=1.8')
	.fromTo('.class__detail--10 .class-tit__2', '1', {alpha: 0, marginLeft: -50}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=2.2')
	.fromTo('.class__detail--10 .class-txt__2', '1', {alpha: 0, marginLeft: -50}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=2.3');

//클래스 상세(투사)
detailScene.class11.addLabel('init')
	.add(() => {
		detailToggle('.class__detail--11');
	}, 'init')
	.fromTo('.class__detail--11 .bg-con', '0.6', {bottom:'100%'}, {bottom:0, ease: Expo.easeInOut}, 'init')
	.fromTo('.class-detail-wrap .sub_nav', 1, {display: 'none', opacity: 0},{display: 'block',opacity: 1}, 'init+=0.5')
	.add(() => {
		$('.class-detail-wrap .sub_nav li').removeClass('on');
		$('.class-detail-wrap .sub_nav .class11').addClass('on');
	}, 'init+=0.5')
	.fromTo('.class__detail--11 .class-char__1-1', '1', {alpha: 0, marginRight: -200}, {alpha:0.1, marginRight:0, ease: Expo.easeInOut}, 'init+=.5')
	.fromTo('.class__detail--11 .class-char__1-2', '1', {alpha: 0, marginRight: -200}, {alpha:0.4, marginRight:0, ease: Expo.easeInOut}, 'init+=.55')
	.fromTo('.class__detail--11 .class-char__1-3', '1', {alpha: 0, marginRight: -200}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=.6')
	.fromTo('.class__detail--11 .class-char__1_f_1', '0.5', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=.6')
	.fromTo('.class__detail--11 .class-char__1_f_2', '0.8', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=.85')
	//.fromTo('.class__detail--11 .class-char__1_f_3', '0.8', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=.86')
	.add(() => {
		TweenMax.fromTo('.class__detail--11 .class-char__1_f_3', 4, {opacity:0},{delay: 1 + Math.random(1.5), opacity:1 + Math.random(0.75), repeat:-1, repeatDelay:0,    yoyo:true,  ease: SlowMo.ease.config(0.7, 0.4, false)});
	}, 'init+=0.86')
	.fromTo('.class__detail--11 .class-char__2-1', '0.8', {alpha: 0, marginLeft: 200, margintTop:50}, {alpha:0.1, marginLeft:0, marginTop:0, ease: Expo.easeInOut}, 'init+=1.0')
	.fromTo('.class__detail--11 .class-char__2-2', '0.8', {alpha: 0,  marginLeft: 200,margintTop:50}, {alpha:0.4, marginLeft:0, marginTop:0, ease: Expo.easeInOut}, 'init+=1.05')
	.fromTo('.class__detail--11 .class-char__2-3', '0.8', {alpha: 0,  marginLeft: 200,margintTop:50}, {alpha:1, marginLeft:0, marginTop:0, ease: Expo.easeInOut}, 'init+=1.1')
	//.fromTo('.class__detail--11 .class-char__2_f_1', '0.5', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=1.1')
	//.fromTo('.class__detail--11 .class-char__2_f_2', '0.5', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=1.35')
	//.fromTo('.class__detail--11 .class-char__2_f_3', '0.5', {alpha: 0}, {alpha: 1, ease: Power3.easeOut}, 'init+=1.36')
	.add(() => {
		TweenMax.fromTo('.class__detail--11 .class-char__2 .fx', 4, {opacity:0},{delay: 1 + Math.random(1.5), opacity:1 + Math.random(0.75), repeat:-1, repeatDelay:0,    yoyo:true,  ease: SlowMo.ease.config(0.7, 0.4, false)});
	}, 'init+=1.0')
	.fromTo('.class__detail--11 .class-tit__1', '1', {alpha: 0, marginRight: 50}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=1.7')
	.fromTo('.class__detail--11 .class-txt__1', '1', {alpha: 0, marginRight: 50}, {alpha:1, marginRight:0, ease: Expo.easeInOut}, 'init+=1.8')
	.fromTo('.class__detail--11 .class-tit__2', '1', {alpha: 0, marginLeft: -50}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=2.2')
	.fromTo('.class__detail--11 .class-txt__2', '1', {alpha: 0, marginLeft: -50}, {alpha:1, marginLeft:0, ease: Expo.easeInOut}, 'init+=2.3');

const mainScene = {
	class1: new TimelineMax({
		paused: true
	}),
	class2: new TimelineMax({
		paused: true
	}),
	class3: new TimelineMax({
		paused: true
	}),
	class4: new TimelineMax({
		paused: true
	}),
	class5: new TimelineMax({
		paused: true
	}),
	class6: new TimelineMax({
		paused: true
	}),
	class7: new TimelineMax({
		paused: true
	}),
	class8: new TimelineMax({
		paused: true
	}),
	class9: new TimelineMax({
		paused: true
	}),
	class10: new TimelineMax({
		paused: true
	}),
	class11: new TimelineMax({
		paused: true
	})
};

//검사
mainScene.class1.addLabel('init')
	.to('.intro-info-wrap', '0.6', {
		opacity: 0,
		display: 'none',
		ease: Quint.easeInOut
	}, 'init')
	.to('.class-detail-wrap', '0.6', {
		opacity: 1,
		ease: Quint.easeInOut
	}, 'init')
	.add(() => {
		detailScene.class1.play();
		isDetail = true;
	}, 'init+=0.6');

//권사
mainScene.class2.addLabel('init')
	.to('.intro-info-wrap', '0.6', {
		opacity: 0,
		display: 'none',
		ease: Quint.easeInOut
	}, 'init')
	.to('.class-detail-wrap', '0.6', {
		opacity: 1,
		ease: Quint.easeInOut
	}, 'init')
	.add(() => {
		detailScene.class2.play();
		isDetail = true;
	}, 'init+=0.6');

//역사
mainScene.class3.addLabel('init')
	.to('.intro-info-wrap', '0.6', {
		opacity: 0,
		display: 'none',
		ease: Quint.easeInOut
	}, 'init')
	.to('.class-detail-wrap', '0.6', {
		opacity: 1,
		ease: Quint.easeInOut
	}, 'init')
	.add(() => {
		detailScene.class3.play();
		isDetail = true;
	}, 'init+=0.6');

//소환사
mainScene.class4.addLabel('init')
	.to('.intro-info-wrap', '0.6', {
		opacity: 0,
		display: 'none',
		ease: Quint.easeInOut
	}, 'init')
	.to('.class-detail-wrap', '0.6', {
		opacity: 1,
		ease: Quint.easeInOut
	}, 'init')
	.add(() => {
		detailScene.class4.play();
		isDetail = true;
	}, 'init+=0.6');

//기공사
mainScene.class5.addLabel('init')
	.to('.intro-info-wrap', '0.6', {
		opacity: 0,
		display: 'none',
		ease: Quint.easeInOut
	}, 'init')
	.to('.class-detail-wrap', '0.6', {
		opacity: 1,
		ease: Quint.easeInOut
	}, 'init')
	.add(() => {
		detailScene.class5.play();
		isDetail = true;
	}, 'init+=0.6');

//암살자
mainScene.class6.addLabel('init')
	.to('.intro-info-wrap', '0.6', {
		opacity: 0,
		display: 'none',
		ease: Quint.easeInOut
	}, 'init')
	.to('.class-detail-wrap', '0.6', {
		opacity: 1,
		ease: Quint.easeInOut
	}, 'init')
	.add(() => {
		detailScene.class6.play();
		isDetail = true;
	}, 'init+=0.6');

//린검사
mainScene.class7.addLabel('init')
	.to('.intro-info-wrap', '0.6', {
		opacity: 0,
		display: 'none',
		ease: Quint.easeInOut
	}, 'init')
	.to('.class-detail-wrap', '0.6', {
		opacity: 1,
		ease: Quint.easeInOut
	}, 'init')
	.add(() => {
		detailScene.class7.play();
		isDetail = true;
	}, 'init+=0.6');

//주술사
mainScene.class8.addLabel('init')
	.to('.intro-info-wrap', '0.6', {
		opacity: 0,
		display: 'none',
		ease: Quint.easeInOut
	}, 'init')
	.to('.class-detail-wrap', '0.6', {
		opacity: 1,
		ease: Quint.easeInOut
	}, 'init')
	.add(() => {
		detailScene.class8.play();
		isDetail = true;
	}, 'init+=0.6');

//기권사
mainScene.class9.addLabel('init')
	.to('.intro-info-wrap', '0.6', {
		opacity: 0,
		display: 'none',
		ease: Quint.easeInOut
	}, 'init')
	.to('.class-detail-wrap', '0.6', {
		opacity: 1,
		ease: Quint.easeInOut
	}, 'init')
	.add(() => {
		detailScene.class9.play();
		isDetail = true;
	}, 'init+=0.6');

//격사
mainScene.class10.addLabel('init')
	.to('.intro-info-wrap', '0.6', {
		opacity: 0,
		display: 'none',
		ease: Quint.easeInOut
	}, 'init')
	.to('.class-detail-wrap', '0.6', {
		opacity: 1,
		ease: Quint.easeInOut
	}, 'init')
	.add(() => {
		detailScene.class10.play();
		isDetail = true;
	}, 'init+=0.6');

//투사
mainScene.class11.addLabel('init')
	.to('.intro-info-wrap', '0.6', {
		opacity: 0,
		display: 'none',
		ease: Quint.easeInOut
	}, 'init')
	.to('.class-detail-wrap', '0.6', {
		opacity: 1,
		ease: Quint.easeInOut
	}, 'init')
	.add(() => {
		detailScene.class11.play();
		isDetail = true;
	}, 'init+=0.6');

let nowArea = '';

CTRL1.on('click', () => {
	nowArea = 'class1';
	mainScene.class1.play();
});
CTRL2.on('click', () => {
	nowArea = 'class2';
	mainScene.class2.play();
});
CTRL3.on('click', () => {
	nowArea = 'class3';
	mainScene.class3.play();
});
CTRL4.on('click', () => {
	nowArea = 'class4';
	mainScene.class4.play();
});
CTRL5.on('click', () => {
	nowArea = 'class5';
	mainScene.class5.play();
});
CTRL6.on('click', () => {
	nowArea = 'class6';
	mainScene.class6.play();
});
CTRL7.on('click', () => {
	nowArea = 'class7';
	mainScene.class7.play();
});
CTRL8.on('click', () => {
	nowArea = 'class8';
	mainScene.class8.play();
});
CTRL9.on('click', () => {
	nowArea = 'class9';
	mainScene.class9.play();
});
CTRL10.on('click', () => {
	nowArea = 'class10';
	mainScene.class10.play();
});
CTRL11.on('click', () => {
	nowArea = 'class11';
	mainScene.class11.play();
});

$(document).on('click', '.class-detail-wrap .sub_nav .class1', () => {
	if (nowArea === 'class1') return;

	if (nowArea === 'class2') {
		offDetail();

		detailScene.class1.play();
		detailScene.class2.seek(0);
		detailScene.class2.pause();
	}
	if (nowArea === 'class3') {
		offDetail();
		detailScene.class1.play();
		detailScene.class3.seek(0);
		detailScene.class3.pause();
	}
	if (nowArea === 'class4') {
		offDetail();
		detailScene.class1.play();
		detailScene.class4.seek(0);
		detailScene.class4.pause();
	}
	if (nowArea === 'class5') {
		offDetail();
		detailScene.class1.play();
		detailScene.class5.seek(0);
		detailScene.class5.pause();
	}
	if (nowArea === 'class6') {
		offDetail();
		detailScene.class1.play();
		detailScene.class6.seek(0);
		detailScene.class6.pause();
	}
	if (nowArea === 'class7') {
		offDetail();
		detailScene.class1.play();
		detailScene.class7.seek(0);
		detailScene.class7.pause();
	}
	if (nowArea === 'class8') {
		offDetail();
		detailScene.class1.play();
		detailScene.class8.seek(0);
		detailScene.class8.pause();
	}
	if (nowArea === 'class9') {
		offDetail();
		detailScene.class1.play();
		detailScene.class9.seek(0);
		detailScene.class9.pause();
	}
	if (nowArea === 'class10') {
		offDetail();
		detailScene.class1.play();
		detailScene.class10.seek(0);
		detailScene.class10.pause();
	}
	if (nowArea === 'class11') {
		offDetail();
		detailScene.class1.play();
		detailScene.class11.seek(0);
		detailScene.class11.pause();
	}

	nowArea = 'class1';
});
$(document).on('click', '.class-detail-wrap .sub_nav .class2', () => {
	if (nowArea === 'class2') return;

	if (nowArea === 'class1') {
		offDetail();

		detailScene.class2.play();
		detailScene.class1.seek(0);
		detailScene.class1.pause();
	}
	if (nowArea === 'class3') {
		offDetail();
		detailScene.class2.play();
		detailScene.class3.seek(0);
		detailScene.class3.pause();
	}
	if (nowArea === 'class4') {
		offDetail();
		detailScene.class2.play();
		detailScene.class4.seek(0);
		detailScene.class4.pause();
	}
	if (nowArea === 'class5') {
		offDetail();
		detailScene.class2.play();
		detailScene.class5.seek(0);
		detailScene.class5.pause();
	}
	if (nowArea === 'class6') {
		offDetail();
		detailScene.class2.play();
		detailScene.class6.seek(0);
		detailScene.class6.pause();
	}
	if (nowArea === 'class7') {
		offDetail();
		detailScene.class2.play();
		detailScene.class7.seek(0);
		detailScene.class7.pause();
	}
	if (nowArea === 'class8') {
		offDetail();
		detailScene.class2.play();
		detailScene.class8.seek(0);
		detailScene.class8.pause();
	}
	if (nowArea === 'class9') {
		offDetail();
		detailScene.class2.play();
		detailScene.class9.seek(0);
		detailScene.class9.pause();
	}
	if (nowArea === 'class10') {
		offDetail();
		detailScene.class2.play();
		detailScene.class10.seek(0);
		detailScene.class10.pause();
	}
	if (nowArea === 'class11') {
		offDetail();
		detailScene.class2.play();
		detailScene.class11.seek(0);
		detailScene.class11.pause();
	}

	nowArea = 'class2';

});
$(document).on('click', '.class-detail-wrap .sub_nav .class3', () => {
	if (nowArea === 'class3') return;

	if (nowArea === 'class1') {
		offDetail();

		detailScene.class3.play();
		detailScene.class1.seek(0);
		detailScene.class1.pause();
	}
	if (nowArea === 'class2') {
		offDetail();

		detailScene.class3.play();
		detailScene.class2.seek(0);
		detailScene.class2.pause();
	}
	if (nowArea === 'class4') {
		offDetail();
		detailScene.class3.play();
		detailScene.class4.seek(0);
		detailScene.class4.pause();
	}
	if (nowArea === 'class5') {
		offDetail();
		detailScene.class3.play();
		detailScene.class5.seek(0);
		detailScene.class5.pause();
	}
	if (nowArea === 'class6') {
		offDetail();
		detailScene.class3.play();
		detailScene.class6.seek(0);
		detailScene.class6.pause();
	}
	if (nowArea === 'class7') {
		offDetail();
		detailScene.class3.play();
		detailScene.class7.seek(0);
		detailScene.class7.pause();
	}
	if (nowArea === 'class8') {
		offDetail();
		detailScene.class3.play();
		detailScene.class8.seek(0);
		detailScene.class8.pause();
	}
	if (nowArea === 'class9') {
		offDetail();
		detailScene.class3.play();
		detailScene.class9.seek(0);
		detailScene.class9.pause();
	}
	if (nowArea === 'class10') {
		offDetail();
		detailScene.class3.play();
		detailScene.class10.seek(0);
		detailScene.class10.pause();
	}
	if (nowArea === 'class11') {
		offDetail();
		detailScene.class3.play();
		detailScene.class11.seek(0);
		detailScene.class11.pause();
	}

	nowArea = 'class3';

});
$(document).on('click', '.class-detail-wrap .sub_nav .class4', () => {
	if (nowArea === 'class4') return;

	if (nowArea === 'class1') {
		offDetail();

		detailScene.class4.play();
		detailScene.class1.seek(0);
		detailScene.class1.pause();
	}
	if (nowArea === 'class2') {
		offDetail();

		detailScene.class4.play();
		detailScene.class2.seek(0);
		detailScene.class2.pause();
	}
	if (nowArea === 'class3') {
		offDetail();
		detailScene.class4.play();
		detailScene.class3.seek(0);
		detailScene.class3.pause();
	}
	if (nowArea === 'class5') {
		offDetail();
		detailScene.class4.play();
		detailScene.class5.seek(0);
		detailScene.class5.pause();
	}
	if (nowArea === 'class6') {
		offDetail();
		detailScene.class4.play();
		detailScene.class6.seek(0);
		detailScene.class6.pause();
	}
	if (nowArea === 'class7') {
		offDetail();
		detailScene.class4.play();
		detailScene.class7.seek(0);
		detailScene.class7.pause();
	}
	if (nowArea === 'class8') {
		offDetail();
		detailScene.class4.play();
		detailScene.class8.seek(0);
		detailScene.class8.pause();
	}
	if (nowArea === 'class9') {
		offDetail();
		detailScene.class4.play();
		detailScene.class9.seek(0);
		detailScene.class9.pause();
	}
	if (nowArea === 'class10') {
		offDetail();
		detailScene.class4.play();
		detailScene.class10.seek(0);
		detailScene.class10.pause();
	}
	if (nowArea === 'class11') {
		offDetail();
		detailScene.class4.play();
		detailScene.class11.seek(0);
		detailScene.class11.pause();
	}

	nowArea = 'class4';
});
$(document).on('click', '.class-detail-wrap .sub_nav .class5', () => {
	if (nowArea === 'class5') return;

	if (nowArea === 'class1') {
		offDetail();

		detailScene.class5.play();
		detailScene.class1.seek(0);
		detailScene.class1.pause();
	}
	if (nowArea === 'class2') {
		offDetail();

		detailScene.class5.play();
		detailScene.class2.seek(0);
		detailScene.class2.pause();
	}
	if (nowArea === 'class3') {
		offDetail();
		detailScene.class5.play();
		detailScene.class3.seek(0);
		detailScene.class3.pause();
	}
	if (nowArea === 'class4') {
		offDetail();
		detailScene.class5.play();
		detailScene.class4.seek(0);
		detailScene.class4.pause();
	}
	if (nowArea === 'class6') {
		offDetail();
		detailScene.class5.play();
		detailScene.class6.seek(0);
		detailScene.class6.pause();
	}
	if (nowArea === 'class7') {
		offDetail();
		detailScene.class5.play();
		detailScene.class7.seek(0);
		detailScene.class7.pause();
	}
	if (nowArea === 'class8') {
		offDetail();
		detailScene.class5.play();
		detailScene.class8.seek(0);
		detailScene.class8.pause();
	}
	if (nowArea === 'class9') {
		offDetail();
		detailScene.class5.play();
		detailScene.class9.seek(0);
		detailScene.class9.pause();
	}
	if (nowArea === 'class10') {
		offDetail();
		detailScene.class5.play();
		detailScene.class10.seek(0);
		detailScene.class10.pause();
	}
	if (nowArea === 'class11') {
		offDetail();
		detailScene.class5.play();
		detailScene.class11.seek(0);
		detailScene.class11.pause();
	}

	nowArea = 'class5';

});
$(document).on('click', '.class-detail-wrap .sub_nav .class6', () => {
	if (nowArea === 'class6') return;

	if (nowArea === 'class1') {
		offDetail();

		detailScene.class6.play();
		detailScene.class1.seek(0);
		detailScene.class1.pause();
	}
	if (nowArea === 'class2') {
		offDetail();

		detailScene.class6.play();
		detailScene.class2.seek(0);
		detailScene.class2.pause();
	}
	if (nowArea === 'class3') {
		offDetail();
		detailScene.class6.play();
		detailScene.class3.seek(0);
		detailScene.class3.pause();
	}
	if (nowArea === 'class4') {
		offDetail();
		detailScene.class6.play();
		detailScene.class4.seek(0);
		detailScene.class4.pause();
	}
	if (nowArea === 'class5') {
		offDetail();
		detailScene.class6.play();
		detailScene.class5.seek(0);
		detailScene.class5.pause();
	}
	if (nowArea === 'class7') {
		offDetail();
		detailScene.class6.play();
		detailScene.class7.seek(0);
		detailScene.class7.pause();
	}
	if (nowArea === 'class8') {
		offDetail();
		detailScene.class6.play();
		detailScene.class8.seek(0);
		detailScene.class8.pause();
	}
	if (nowArea === 'class9') {
		offDetail();
		detailScene.class6.play();
		detailScene.class9.seek(0);
		detailScene.class9.pause();
	}
	if (nowArea === 'class10') {
		offDetail();
		detailScene.class6.play();
		detailScene.class10.seek(0);
		detailScene.class10.pause();
	}
	if (nowArea === 'class11') {
		offDetail();
		detailScene.class6.play();
		detailScene.class11.seek(0);
		detailScene.class11.pause();
	}

	nowArea = 'class6';

});
$(document).on('click', '.class-detail-wrap .sub_nav .class7', () => {
	if (nowArea === 'class7') return;

	if (nowArea === 'class1') {
		offDetail();

		detailScene.class7.play();
		detailScene.class1.seek(0);
		detailScene.class1.pause();
	}
	if (nowArea === 'class2') {
		offDetail();

		detailScene.class7.play();
		detailScene.class2.seek(0);
		detailScene.class2.pause();
	}
	if (nowArea === 'class3') {
		offDetail();
		detailScene.class7.play();
		detailScene.class3.seek(0);
		detailScene.class3.pause();
	}
	if (nowArea === 'class4') {
		offDetail();
		detailScene.class7.play();
		detailScene.class4.seek(0);
		detailScene.class4.pause();
	}
	if (nowArea === 'class5') {
		offDetail();
		detailScene.class7.play();
		detailScene.class5.seek(0);
		detailScene.class5.pause();
	}
	if (nowArea === 'class6') {
		offDetail();
		detailScene.class7.play();
		detailScene.class6.seek(0);
		detailScene.class6.pause();
	}
	if (nowArea === 'class8') {
		offDetail();
		detailScene.class7.play();
		detailScene.class8.seek(0);
		detailScene.class8.pause();
	}
	if (nowArea === 'class9') {
		offDetail();
		detailScene.class7.play();
		detailScene.class9.seek(0);
		detailScene.class9.pause();
	}
	if (nowArea === 'class10') {
		offDetail();
		detailScene.class7.play();
		detailScene.class10.seek(0);
		detailScene.class10.pause();
	}
	if (nowArea === 'class11') {
		offDetail();
		detailScene.class7.play();
		detailScene.class11.seek(0);
		detailScene.class11.pause();
	}

	nowArea = 'class7';

});
$(document).on('click', '.class-detail-wrap .sub_nav .class8', () => {
	if (nowArea === 'class8') return;

	if (nowArea === 'class1') {
		offDetail();

		detailScene.class8.play();
		detailScene.class1.seek(0);
		detailScene.class1.pause();
	}
	if (nowArea === 'class2') {
		offDetail();

		detailScene.class8.play();
		detailScene.class2.seek(0);
		detailScene.class2.pause();
	}
	if (nowArea === 'class3') {
		offDetail();
		detailScene.class8.play();
		detailScene.class3.seek(0);
		detailScene.class3.pause();
	}
	if (nowArea === 'class4') {
		offDetail();
		detailScene.class8.play();
		detailScene.class4.seek(0);
		detailScene.class4.pause();
	}
	if (nowArea === 'class5') {
		offDetail();
		detailScene.class8.play();
		detailScene.class5.seek(0);
		detailScene.class5.pause();
	}
	if (nowArea === 'class6') {
		offDetail();
		detailScene.class8.play();
		detailScene.class6.seek(0);
		detailScene.class6.pause();
	}
	if (nowArea === 'class7') {
		offDetail();
		detailScene.class8.play();
		detailScene.class7.seek(0);
		detailScene.class7.pause();
	}
	if (nowArea === 'class9') {
		offDetail();
		detailScene.class8.play();
		detailScene.class9.seek(0);
		detailScene.class9.pause();
	}
	if (nowArea === 'class10') {
		offDetail();
		detailScene.class8.play();
		detailScene.class10.seek(0);
		detailScene.class10.pause();
	}
	if (nowArea === 'class11') {
		offDetail();
		detailScene.class8.play();
		detailScene.class11.seek(0);
		detailScene.class11.pause();
	}

	nowArea = 'class8';

});
$(document).on('click', '.class-detail-wrap .sub_nav .class9', () => {
	if (nowArea === 'class9') return;

	if (nowArea === 'class1') {
		offDetail();

		detailScene.class9.play();
		detailScene.class1.seek(0);
		detailScene.class1.pause();
	}
	if (nowArea === 'class2') {
		offDetail();

		detailScene.class9.play();
		detailScene.class2.seek(0);
		detailScene.class2.pause();
	}
	if (nowArea === 'class3') {
		offDetail();
		detailScene.class9.play();
		detailScene.class3.seek(0);
		detailScene.class3.pause();
	}
	if (nowArea === 'class4') {
		offDetail();
		detailScene.class9.play();
		detailScene.class4.seek(0);
		detailScene.class4.pause();
	}
	if (nowArea === 'class5') {
		offDetail();
		detailScene.class9.play();
		detailScene.class5.seek(0);
		detailScene.class5.pause();
	}
	if (nowArea === 'class6') {
		offDetail();
		detailScene.class9.play();
		detailScene.class6.seek(0);
		detailScene.class6.pause();
	}
	if (nowArea === 'class7') {
		offDetail();
		detailScene.class9.play();
		detailScene.class7.seek(0);
		detailScene.class7.pause();
	}
	if (nowArea === 'class8') {
		offDetail();
		detailScene.class9.play();
		detailScene.class8.seek(0);
		detailScene.class8.pause();
	}
	if (nowArea === 'class10') {
		offDetail();
		detailScene.class9.play();
		detailScene.class10.seek(0);
		detailScene.class10.pause();
	}
	if (nowArea === 'class11') {
		offDetail();
		detailScene.class9.play();
		detailScene.class11.seek(0);
		detailScene.class11.pause();
	}

	nowArea = 'class9';

});
$(document).on('click', '.class-detail-wrap .sub_nav .class10', () => {
	if (nowArea === 'class10') return;
	if (nowArea === 'class1') {
		offDetail();

		detailScene.class10.play();
		detailScene.class1.seek(0);
		detailScene.class1.pause();
	}
	if (nowArea === 'class2') {
		offDetail();

		detailScene.class10.play();
		detailScene.class2.seek(0);
		detailScene.class2.pause();
	}
	if (nowArea === 'class3') {
		offDetail();
		detailScene.class10.play();
		detailScene.class3.seek(0);
		detailScene.class3.pause();
	}
	if (nowArea === 'class4') {
		offDetail();
		detailScene.class10.play();
		detailScene.class4.seek(0);
		detailScene.class4.pause();
	}
	if (nowArea === 'class5') {
		offDetail();
		detailScene.class10.play();
		detailScene.class5.seek(0);
		detailScene.class5.pause();
	}
	if (nowArea === 'class6') {
		offDetail();
		detailScene.class10.play();
		detailScene.class6.seek(0);
		detailScene.class6.pause();
	}
	if (nowArea === 'class7') {
		offDetail();
		detailScene.class10.play();
		detailScene.class7.seek(0);
		detailScene.class7.pause();
	}
	if (nowArea === 'class8') {
		offDetail();
		detailScene.class10.play();
		detailScene.class8.seek(0);
		detailScene.class8.pause();
	}
	if (nowArea === 'class9') {
		offDetail();
		detailScene.class10.play();
		detailScene.class9.seek(0);
		detailScene.class9.pause();
	}
	if (nowArea === 'class11') {
		offDetail();
		detailScene.class10.play();
		detailScene.class11.seek(0);
		detailScene.class11.pause();
	}

	nowArea = 'class10';

});
$(document).on('click', '.class-detail-wrap .sub_nav .class11', () => {
	if (nowArea === 'class11') return;

	if (nowArea === 'class1') {
		offDetail();

		detailScene.class11.play();
		detailScene.class1.seek(0);
		detailScene.class1.pause();
	}
	if (nowArea === 'class2') {
		offDetail();

		detailScene.class11.play();
		detailScene.class2.seek(0);
		detailScene.class2.pause();
	}
	if (nowArea === 'class3') {
		offDetail();
		detailScene.class11.play();
		detailScene.class3.seek(0);
		detailScene.class3.pause();
	}
	if (nowArea === 'class4') {
		offDetail();
		detailScene.class11.play();
		detailScene.class4.seek(0);
		detailScene.class4.pause();
	}
	if (nowArea === 'class5') {
		offDetail();
		detailScene.class11.play();
		detailScene.class5.seek(0);
		detailScene.class5.pause();
	}
	if (nowArea === 'class6') {
		offDetail();
		detailScene.class11.play();
		detailScene.class6.seek(0);
		detailScene.class6.pause();
	}
	if (nowArea === 'class7') {
		offDetail();
		detailScene.class11.play();
		detailScene.class7.seek(0);
		detailScene.class7.pause();
	}
	if (nowArea === 'class8') {
		offDetail();
		detailScene.class11.play();
		detailScene.class8.seek(0);
		detailScene.class8.pause();
	}
	if (nowArea === 'class9') {
		offDetail();
		detailScene.class11.play();
		detailScene.class9.seek(0);
		detailScene.class9.pause();
	}
	if (nowArea === 'class10') {
		offDetail();
		detailScene.class11.play();
		detailScene.class10.seek(0);
		detailScene.class10.pause();
	}

	nowArea = 'class11';
});
let initAnimation = false;

const onStart = () => {
	resetAnimation();
	onIndex();
};

const onComplete = () => {

};

const onAnimation = () => {
	introTimeline.play();
};

const closeAnimation = () => {
	//resetAnimation();
};
const checkDetail = () => {
	return isDetail
}
export default {
	onStart,
	onComplete,
	onAnimation,
	checkDetail
};



// WEBPACK FOOTER //
// ./src/js/page/intro.js